export default __webpack_public_path__ + "static/media/smart-tent-c.d27d1118.jpeg";